import { combineReducers } from 'redux';
import powerBIReducer from '../reducers/powerBIReducer'
import applicationSettingsReducer from './applicationSettingsReducer'


const rootReducer = combineReducers({
    powerBIReducer, applicationSettingsReducer
  }
);

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.ts